import { render, staticRenderFns } from "./WorkEnvironment2.vue?vue&type=template&id=0115b2be&scoped=true"
import script from "./WorkEnvironment2.vue?vue&type=script&lang=js"
export * from "./WorkEnvironment2.vue?vue&type=script&lang=js"
import style0 from "./WorkEnvironment2.vue?vue&type=style&index=0&id=0115b2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115b2be",
  null
  
)

export default component.exports